import { getStrings } from "@microsoft/shifts-experiences-shared";
import { Body1, Button, Flex } from "@microsoft/shifts-ui-core";
import { observer } from "mobx-react";
import * as React from "react";

import { EnabledConstraintData } from "../SchedulingRulesPanel.mappers";
import { useStyles } from "../SchedulingRulesPanel.styles";

import { EmptyConstraintsList } from "./EmptyConstraintsList";

/**
 * Renders the list of scheduling constraints.
 * @param props The properties.
 * @returns The constraints list component.
 */
export const ConstraintsList: React.FC<ConstraintsListProps> = observer(props => {
    const { constraints, settingsButtonProps } = props;
    const styles = useStyles();

    if (!constraints || constraints.length === 0) {
        return (
            <EmptyConstraintsList settingsButtonProps={settingsButtonProps} />
        );
    }

    return (
        <>
            <Flex className={styles.content}>
                {constraints.map((constraint) => (
                    <React.Fragment key={constraint.key}>
                        <Body1 className={styles.ruleLabel}>
                            {constraint.label}
                        </Body1>
                        <Body1 className={styles.ruleValue}>
                            {constraint.unit === "hours"
                                ? getStrings("schedulingConstraints", "hoursUnit", [constraint.value.toString()])
                                : getStrings("schedulingConstraints", "daysUnit", [constraint.value.toString()])
                            }
                        </Body1>
                    </React.Fragment>
                ))}
            </Flex>
            <Button
                className={styles.navigateButton}
                {...settingsButtonProps}
            >
                {getStrings("schedulingConstraints", "navigateToSettings")}
            </Button>
        </>
    );
});

/**
 * Props for the ConstraintsList component.
 */
export interface ConstraintsListProps {
    /**
     * The list of enabled scheduling constraints.
     */
    constraints: EnabledConstraintData[];
    /**
     * Props for the settings button.
     */
    settingsButtonProps: {
        /**
         * The label for the settings button.
         */
        onClick: () => void;
    };
}